import { Navigate, useLocation } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useAuth, homeFor } from "../context/AuthContext";

export const ProtectedRoute = ({ roles, children }) => {
  const { user } = useAuth();
  const loc = useLocation();
  if (user === null) return <div className="grid min-h-[60vh] place-items-center"><Loader2 className="h-6 w-6 animate-spin text-primary" /></div>;
  if (!user) return <Navigate to={`/login?next=${encodeURIComponent(loc.pathname)}`} replace />;
  if (roles && !roles.includes(user.role)) return <Navigate to={homeFor(user)} replace />;
  return children;
};

export const PortalShell = ({ title, subtitle, tabs, active, onTab, children, testid }) => (
  <div className="min-h-[80vh] bg-background" data-testid={testid}>
    <div className="relative overflow-hidden border-b bg-[#FFF5F7]">
      <div className="blob absolute -right-20 -top-24 h-64 w-64 bg-primary/10" />
      <div className="relative mx-auto max-w-7xl px-4 pt-8 sm:px-6 lg:px-8">
        <h1 className="text-3xl font-extrabold sm:text-4xl">{title}</h1>
        {subtitle && <p className="mt-1 text-sm text-muted-foreground">{subtitle}</p>}
        <nav className="-mb-px mt-6 flex gap-1 overflow-x-auto" data-testid={`${testid}-nav`}>
          {tabs.map(([k, label]) => (
            <button key={k} onClick={() => onTab(k)} data-testid={`tab-${k}`}
              className={`whitespace-nowrap border-b-[3px] px-4 py-2.5 text-sm font-bold transition-colors ${active === k ? "border-primary text-primary" : "border-transparent text-muted-foreground hover:text-foreground"}`}>
              {label}
            </button>
          ))}
        </nav>
      </div>
    </div>
    <div className="mx-auto max-w-7xl px-4 py-8 sm:px-6 lg:px-8">{children}</div>
  </div>
);

export const Stat = ({ label, value, testid, tone }) => (
  <div className="rounded-2xl border bg-white p-5 transition-transform duration-300 hover:-translate-y-0.5" data-testid={testid}>
    <p className="text-xs font-semibold uppercase tracking-wider text-muted-foreground">{label}</p>
    <p className={`mt-2 font-display text-3xl font-bold ${tone || ""}`}>{value}</p>
  </div>
);

export const Empty = ({ children }) => (
  <div className="rounded-lg border border-dashed bg-white p-10 text-center text-sm text-muted-foreground">{children}</div>
);
